<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{
            $t("module.object_count")
          }}</label>
          <el-slider
            v-model="maxStepCount"
            :step="1"
            :min="6"
            :max="12"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label class="dark-inverted d-block" for="">{{
            $t("module.eksen")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="direction"
            :active-text="$t('module.horizontal')"
            :active-value="'yatay'"
            :inactive-value="'dikey'"
            :inactive-text="$t('module.vertical')"
          >
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      id="goz_esnetme"
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
      :style="{ flexDirection: direction == 'yatay' ? 'row' : 'column' }"
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <img
        v-for="item in maxStepCount + 1"
        :src="icons[item - 1].icon"
        :style="{
          display: icons[item - 1].display,
          width:
            (direction == 'yatay'
              ? wrapper.width / maxStepCount - 10
              : wrapper.height / maxStepCount - 10) + 'px',
          margin: '5px',
        }"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: ["config"],
  name: "AcilanNesnelerYatay",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      mode: 1,
      interval: null,
      wrapper: {
        width: 0,
        height: 0,
      },
      step: 1,
      maxStepCount: 12,
      icons: [
        "/static/images/sirali//346167.png",
        "/static/images/sirali//740934.png",
        "/static/images/sirali//616546.png",
        "/static/images/sirali//741407.png",
        "/static/images/sirali//3039367.png",
        "/static/images/sirali//2232688.png",
        "/static/images/sirali//1212998.png",
        "/static/images/sirali//889518.png",
        "/static/images/sirali//814513.png",
        "/static/images/sirali//616430.png",
        "/static/images/sirali//875011.png",
        "/static/images/sirali//874983.png",
        "/static/images/sirali//874985.png",
        "/static/images/sirali//874990.png",
      ],
      direction: "yatay",
      settings: false,
      autoLevel: 0,
      tourCount: 0,
    };
  },
  created() {
    this.icons = this.icons.map((k) => {
      return {
        icon: k,
        display: "none",
      };
    });

    if (this.config != null && this.config != undefined) {
      this.speed = this.config.speed;
      this.maxStepCount = parseInt(this.config.level);
      this.direction = this.config.direction;
      this.autoLevel = this.config.auto_level;
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };

    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    start() {
      this.interval = setInterval(() => {
        if (this.pause) return;
        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        if (this.step == this.maxStepCount + 1) {
          this.tourCount += 1;
          this.step = 1;
          this.icons = _.shuffle(
            this.icons.map((k) => {
              return {
                ...k,
                display: "none",
              };
            })
          );
          return;
        }

        this.step += 1;

        this.icons[this.step - 1].display = "inline-block";
      }, this.currentSpeed);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    maxStepCount: function () {
      this.icons = _.shuffle(
        this.icons.map((k) => {
          return {
            ...k,
            display: "none",
          };
        })
      );
      this.step = 1;
      clearInterval(this.interval);
      this.start();
    },
    step: function () {
      if (this.autoLevel == 0) return;
      if (this.step == this.maxStepCount + 1) {
        this.speed = Math.min(
          this.speed + 1,
          this.config && this.config.max_speed
            ? this.config.max_speed
            : this.speeds.length
        );

        this.maxStepCount = Math.min(
          this.maxStepCount + 1,
          this.config && this.config.maxStepCount
            ? this.config.maxStepCount
            : 12
        );
      }
    },
    tourCount: function () {
      if (this.autoLevel == 0) return;
      if (this.tourCount % 2 == 0) {
        this.direction = this.direction == "dikey" ? "yatay" : "dikey";
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/AcilanNesnelerYatay.vue